// extracted by mini-css-extract-plugin
module.exports = {"tags":"Tags-module--tags--2w0ma","tag":"Tags-module--tag--1UaAR"};